import React, { Component, ErrorInfo, ReactNode } from 'react';
import { trackException } from '../telemetry';

interface IProps {
	children: ReactNode;
}

interface IState {
	hasError: boolean;
}

/**
 * Last-resort safety net: React unmounts the whole tree on any uncaught
 * render/effect error (e.g. a third-party SDK throwing during mount), which
 * otherwise shows a blank white page with nothing the user can do about it.
 */
class ErrorBoundary extends Component<IProps, IState> {
	state: IState = { hasError: false };

	static getDerivedStateFromError(): IState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Unhandled UI error:', error, errorInfo);
		trackException(error, { componentStack: errorInfo.componentStack || '' });
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					className='d-flex flex-column align-items-center justify-content-center text-center'
					style={{ height: '100vh', padding: 24, fontFamily: "'Quicksand', sans-serif" }}>
					<h3 style={{ fontWeight: 700, marginBottom: 8 }}>Something went wrong</h3>
					<p className='text-muted' style={{ marginBottom: 20 }}>
						Please reload the page. If this keeps happening, let us know.
					</p>
					<button
						type='button'
						onClick={() => window.location.reload()}
						style={{
							border: 'none',
							borderRadius: 12,
							padding: '10px 24px',
							fontWeight: 600,
							fontFamily: "'Quicksand', sans-serif",
							backgroundColor: '#4d69fa',
							color: '#fff',
							cursor: 'pointer',
						}}>
						Reload page
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
